// Modified CVUploadButton with hasCv as a prop
import React, { useRef, useState, useEffect } from 'react';
import { addCV } from 'js/profiles/api/curriculumVitaeApi';
import {
  trackAnalyticsClick,
  useAnalyticsImpression,
} from 'js/analytics/metrics/analyticsTracking';

export const CVUploadButton = ({ hasCv: initialHasCv = undefined }) => {
  const fileInputRef = useRef(null);
  const uploadButtonRef = useRef(null);
  const [hasCv, setHasCv] = useState(initialHasCv);
  const [isLoading, setIsLoading] = useState(initialHasCv === undefined);

  useAnalyticsImpression(uploadButtonRef, 'analytics-cv-upload', 'cv_upload');

  // Only check API if hasCv wasn't provided; allows for future reusability elsewhere
  useEffect(() => {
    if (initialHasCv !== undefined) {
      setHasCv(initialHasCv);
      setIsLoading(false);
    } else {
      const checkStatus = async () => {
        try {
          const exists = await checkCvExists();
          setHasCv(exists);
          setIsLoading(false);
        } catch (error) {
          console.error('Error checking CV status:', error);
          setIsLoading(false);
        }
      };

      checkStatus();
    }
  }, [initialHasCv]);

  const handleButtonClick = (event) => {
    event.preventDefault();
    trackAnalyticsClick('analytics-cv-upload');
    fileInputRef.current?.click();
  };

  const handleCVChange = async (event) => {
    const file = event.target.files?.[0];
    if (file) {
      try {
        setIsLoading(true);
        await addCV(file);
        setHasCv(true);
        setIsLoading(false);
      } catch (error) {
        console.error('Error uploading CV:', error);
        setIsLoading(false);
      }
    }
  };

  if (isLoading) {
    return (
      <div className="u-mt5x">
        <i className="fa fa-spin fa-spinner"></i> Checking CV status...
      </div>
    );
  }

  if (hasCv) {
    return (
      <div className="u-mt5x">
        <p className="text-success">
          <i className="fa fa-check-circle"></i> Your CV has been uploaded.
        </p>
        <p>Check back later to see analytics for your CV.</p>
      </div>
    );
  }

  return (
    <>
      <input
        type="file"
        accept=".txt, .doc, .docx, .pdf, .rtf"
        onChange={handleCVChange}
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
      <button
        className="btn btn-default btn-success btn-academia-green btn-lg u-mt5x"
        ref={uploadButtonRef}
        onClick={handleButtonClick}
      >
        Upload CV
      </button>
    </>
  );
};
